import React from 'react'

import Feespage from "./fees-page/Feespage.js"
const Fees = () => {
  return (
    <>
      <Feespage />
    </>
  )
}

export default Fees 
